// extracted by mini-css-extract-plugin
export default {"accordionExportButtonWrapper":"PreviewWordControl_accordionExportButtonWrapper__ODHsK","previewARcontrolPDF":"PreviewWordControl_previewARcontrolPDF__k1joy"};